module.exports = __webpack_public_path__ + "img/eco.2173886d.png";